export const singleGenderMessage = function (eventgendermen,eventgenderwomen) {

	let message = ''

	if(eventgendermen == false)
	{
		message = 'WOMEN only event'
	}
	else if(eventgenderwomen == false)
	{
		message = 'MEN only event'
	}
	return message
}    


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Logic/singleGenderMessage.js